'use strict';

document.addEventListener('DOMContentLoaded', () => {
  // 要素を選択
  const heroElement = document.querySelector('.js-hero') as HTMLElement;
  const headerNavButton = document.querySelector(
    '.headerNavigationButton[data-js="trueSp"]'
  ) as HTMLElement;

  // IntersectionObserverの設定
  const options: IntersectionObserverInit = {
    root: null, // ビューポートをルートとして使用
    threshold: 0, // ヒーロー要素がビューポートから完全に外れたときにコールバックをトリガー
  };

  // IntersectionObserverのコールバック
  const observerCallback: IntersectionObserverCallback = (
    entries,
    observer
  ) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        // ヘッダーナビゲーションボタンに 'position: fixed' を適用
        headerNavButton.classList.add('is-active');
      } else {
        // ヘッダーナビゲーションボタンの 'position: fixed' を解除
        headerNavButton.classList.remove('is-active');
      }
    });
  };

  // IntersectionObserverのインスタンスを作成
  const observer = new IntersectionObserver(observerCallback, options);

  // ヒーロー要素を監視
  observer.observe(heroElement);
});
